export const centroRecreativoVacio = { id: 0, descripcion: ""}